import initContactMaps from './components/contact-maps';
import initContactForm from './components/contact-form';

const mapEls = document.querySelectorAll('.js-contact-map');

if (mapEls && mapEls.length > 0) {
    initContactMaps(mapEls);
}

const contactForm = document.querySelector('.js-contact-form');

if (contactForm) {
    initContactForm(contactForm);
}
